export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      projects: "Projects",
      contact: "Contact",
      quote: "Get a free quote",
      call: "Call now",
      switchTo: "हिंदी",
    },
    hero: {
      eyebrow: "Electrical • Automation • Energy",
      titleA: "Power that works.",
      titleB: "Automation that pays.",
      promise:
        "From complete home wiring to plant-wide automation, we plan, install and maintain electrical systems that stay safe and reliable for years — with written quotes, certified work and 24/7 support.",
      ctaQuote: "Get a free quote",
      ctaWhatsapp: "Chat on WhatsApp",
      badges: ["Certified team", "Warranty on work", "24/7 emergency support"],
      statCard: { value: "24/7", label: "Emergency support, always on" },
      projectCard: { value: "500+", label: "Projects completed" },
    },
    about: {
      eyebrow: "About Nextron",
      title: "Trusted hands behind every connection",
      body: "Nextron Electrical & Automation Solutions — formerly Neutronics — is a single-window contractor for electrical installation, industrial automation, panel building and energy solutions. One team handles your job from the first survey to the final handover, so nothing falls through the cracks.",
      points: [
        "Single point of contact, survey to handover",
        "Transparent, itemised written quotes",
        "Genuine materials, certified workmanship",
        "After-sales support with 12-month workmanship warranty",
      ],
      warrantyBadge: "Workmanship warranty",
    },
    gallery: {
      eyebrow: "Recent work",
      title: "On the ground, every day",
      viewAll: "View all projects",
      items: [
        { img: "electrician_wiring", caption: "Home electrification in progress" },
        { img: "factory_equipment", caption: "Automation line at a manufacturing unit" },
        { img: "worker_hardhat", caption: "Panel installation on site" },
        { img: "solar_roof_workers", caption: "Rooftop solar installation" },
      ],
    },
    homeServices: {
      eyebrow: "For your home",
      title: "Home & smart services",
      subtitle: "Small jobs, done same-day — book on call or WhatsApp.",
      viewAll: "See home services",
      bookNow: "Book now",
      items: [
        { id: "cctv", img: "cctv", title: "CCTV Camera Installation", desc: "Indoor-outdoor camera setup, DVR/NVR and mobile live-view configured for you." },
        { id: "tv", img: "tv_wall", title: "TV Wall-Mount & Setup", desc: "Secure wall-mounting, hidden wiring, set-top box and soundbar setup." },
        { id: "geyser", img: "appliance_service", title: "Geyser & Water Heater Service", desc: "Installation, descaling and safety check for all brands." },
        { id: "fridge", img: "appliance_repair", title: "Fridge & Appliance Care", desc: "Fridge, washing machine and appliance repair at your doorstep." },
        { id: "wifi", img: "wifi_router", title: "WiFi & Networking Setup", desc: "Router setup, range extenders and seamless WiFi in every room." },
        { id: "smart", img: "smart_home", title: "Smart Device Installation", desc: "Smart switches, video doorbells, locks and speakers — set up with a demo." },
      ],
    },
    extraServices: {
      eyebrow: "For offices & sites",
      title: "Communication & power, arranged",
      subtitle: "Site-to-site internet, intercoms, radios and standby power — set up and supported by the same team.",
      bookNow: "Book now",
      items: [
        { id: "bridge", img: "wireless_bridge", title: "Wireless Bridge & Internet Sharing", desc: "Point-to-point wireless bridge to share internet between buildings, offices and sites." },
        { id: "intercom", img: "smart_lock", title: "Intercom & Video Door Phone", desc: "Audio and video intercom for homes, offices and apartments." },
        { id: "walkie", img: "walkie_talkie", title: "Walkie-Talkie (Two-Way Radio)", desc: "Radio sets for sites, events and security teams — supply and programming." },
        { id: "dg", img: "dg_rent", title: "DG Set on Rent", desc: "Silent DG sets on rent for functions, sites and backup power — delivery and installation included." },
      ],
    },
    smallJobs: {
      eyebrow: "Everyday fixes",
      title: "Small electrician jobs for your home",
      subtitle: "One call and a Nextron electrician is at your door — same-day visits for small jobs.",
      items: [
        { id: "fan", img: "ceiling_fan", title: "Ceiling Fan Installation" },
        { id: "light", img: "lights", title: "Lights & Chandelier Fitting" },
        { id: "switchboard", img: "electrician_wiring", title: "Switchboard & Socket Repair" },
        { id: "inverter", img: "appliance_repair", title: "Inverter & Battery Setup" },
        { id: "doorbell", img: "cctv", title: "Doorbell & Wiring Fix" },
        { id: "mcb", img: "breakers", title: "MCB & Fuse Repair" },
      ],
    },
    stats: [
      { value: 500, suffix: "+", label: "Projects completed" },
      { value: 15, suffix: "+", label: "Years of experience" },
      { value: 250, suffix: "+", label: "Happy clients served" },
      { value: 24, suffix: "/7", label: "Emergency support" },
    ],
    steps: {
      eyebrow: "How it works",
      title: "From first call to final handover in 3 steps",
      subtitle: "No surprises, no hidden costs — a clear process from start to finish.",
      items: [
        {
          title: "Share your requirement",
          desc: "Call, WhatsApp or fill the form. Tell us the job — a single fault or a full plant automation, we take both.",
        },
        {
          title: "Free survey & written quote",
          desc: "Our engineer visits, measures the load and gives you a clear, itemised written quote. Free of charge.",
        },
        {
          title: "Installation, testing & support",
          desc: "Certified installation with full testing and handover — plus after-sales support and warranty.",
        },
      ],
    },
    servicesTeaser: {
      eyebrow: "What we do",
      title: "Electrical and automation, end to end",
      subtitle: "One team for wiring, panels, automation, maintenance and power solutions.",
      customTitle: "Need something custom?",
      customDesc: "Tell us your problem — we'll propose the right electrical or automation solution.",
      customCta: "Talk to us",
      viewAll: "View all services",
    },
    why: {
      eyebrow: "Why choose us",
      title: "Work you can trust, people you can reach",
      items: [
        { title: "Certified & safe work", desc: "Trained electricians, genuine materials and full safety standards on every job." },
        { title: "On-time delivery", desc: "We commit to a timeline and keep it — no endless delays, no excuses." },
        { title: "Warranty on work", desc: "12-month workmanship warranty on our installations and panels." },
        { title: "Experienced team", desc: "Engineers and technicians with years of industrial and commercial experience." },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Questions people ask before calling us",
      items: [
        { q: "Do you charge for surveys or quotes?", a: "No. Site surveys and written quotes are completely free and without obligation." },
        { q: "How soon can work start?", a: "Most jobs start within 2–5 working days of quote approval. Emergency breakdown support is same-day." },
        { q: "Which areas do you serve?", a: "We serve the city and surrounding industrial areas; larger projects are taken up across the state." },
        { q: "Is there a warranty on your work?", a: "Yes — a 12-month workmanship warranty on installations and panels we build, plus manufacturer warranty on equipment." },
        { q: "Do you handle small home jobs?", a: "Yes. From a single wiring fault to complete home electrification — no job is too small." },
        { q: "Can you automate an existing machine or panel?", a: "Yes — we retrofit PLC/VFD automation into existing machines, lines and panels without stopping your production for long." },
      ],
    },
    finalCta: {
      title: "Need power that just works?",
      subtitle: "Send one message. Get a free quote within 24 hours — or call us directly for emergencies.",
      call: "Call now",
      whatsapp: "WhatsApp us",
      quote: "Get a free quote",
    },
    servicesPage: {
      eyebrow: "Services",
      title: "Five ways we keep you powered",
      subtitle: "Electrical, automation and energy work for homes, shops, factories and infrastructure — with written quotes and warranty.",
      enquire: "Enquire now",
      standardsTitle: "Standards & practices we follow",
      standards: ["IS / IEC wiring standards", "IP-rated panel enclosures", "Load study before every job", "Test report with handover", "Documented earthing & safety audit"],
      items: [
        {
          id: "electrical",
          title: "Electrical Installation & Wiring",
          desc: "Complete electrification for homes, shops and factories — safe wiring that passes inspection the first time.",
          features: ["Complete home & shop electrification", "Industrial heavy wiring & cabling", "Conduits, earthing & safety compliance"],
        },
        {
          id: "automation",
          title: "Industrial Automation & Control Panels",
          desc: "PLC, VFD and SCADA based automation that reduces manual errors and increases output.",
          features: ["PLC / SCADA & HMI programming", "VFD & motor control automation", "Retrofit of existing machines & lines"],
        },
        {
          id: "panels",
          title: "Custom Panel Building",
          desc: "Panels built to your load calculation — wired, labelled and tested before dispatch.",
          features: ["LT/HT panels, APFC & MCC", "Distribution boards (DB) & switchgear", "Load calculation & testing"],
        },
        {
          id: "maintenance",
          title: "Maintenance & Breakdown Support",
          desc: "Preventive maintenance and rapid breakdown response so your production never stops for long.",
          features: ["Preventive maintenance contracts", "24/7 breakdown support", "Thermal scanning & safety audits"],
        },
        {
          id: "power",
          title: "Power & Energy Solutions",
          desc: "Solar, surge protection and energy-saving upgrades that cut your electricity bill.",
          features: ["Rooftop solar & net-metering", "Surge protection & power conditioning", "Energy-saving upgrades"],
        },
      ],
    },
    projectsPage: {
      eyebrow: "Projects",
      title: "Work we have delivered",
      subtitle: "A look at the kind of installations and automation we handle every day.",
      filters: { all: "All", industrial: "Industrial Automation", panels: "Panels & Switchgear", wiring: "Commercial Wiring", energy: "Smart Energy" },
      items: [
        { img: "panel_testing", cat: "industrial", title: "PLC control panel commissioning at a textile plant", meta: "Industrial · 2024" },
        { img: "panel_wiring", cat: "panels", title: "480-point control panel wiring for process automation", meta: "Panels & Switchgear · 2024" },
        { img: "breakers", cat: "panels", title: "LT distribution panel upgrade for a commercial complex", meta: "Panels & Switchgear · 2023" },
        { img: "switchbox", cat: "wiring", title: "Complete shop-floor wiring & DB installation", meta: "Commercial Wiring · 2024" },
        { img: "solar_farm", cat: "energy", title: "Rooftop solar + net-metering integration", meta: "Smart Energy · 2023" },
        { img: "solar_tech", cat: "energy", title: "Surge protection & earthing audit for a warehouse", meta: "Smart Energy · 2024" },
        { img: "solar_panels", cat: "energy", title: "Smart energy monitoring for an office park", meta: "Smart Energy · 2025" },
        { img: "factory_machine", cat: "industrial", title: "Production line automation retrofit for a manufacturing unit", meta: "Industrial · 2025" },
        { img: "solar_roof_workers", cat: "energy", title: "Solar installation crew completing a rooftop array", meta: "Smart Energy · 2025" },
        { img: "breakers_white", cat: "panels", title: "Feeder panel with breaker interlocks for a cold-storage unit", meta: "Panels & Switchgear · 2024" },
      ],
      note: "Sample gallery — project photos and captions will be replaced with the company's actual work.",
    },
    contactPage: {
      eyebrow: "Contact",
      title: "Tell us what you need",
      subtitle: "Fill the form and we'll call you back — usually the same working day. Or reach us directly below.",
      form: {
        name: "Your name",
        namePh: "e.g. Rahul Sharma",
        phone: "Phone number",
        phonePh: "+91 ...",
        email: "Email (optional)",
        emailPh: "you@example.com",
        service: "Service needed",
        servicePh: "What do you need?",
        other: "Other / not sure",
        message: "Your message",
        messagePh: "Describe the job — location, size, any deadlines...",
        submit: "Send enquiry",
        sending: "Sending...",
        success: "Enquiry sent!",
        successDesc: "We'll call or WhatsApp you back shortly. For anything urgent, message us on WhatsApp.",
        error: "Could not send. Please try again or use WhatsApp.",
      },
      info: {
        title: "Direct contact",
        phoneLabel: "Call us",
        whatsappLabel: "WhatsApp",
        emailLabel: "Email",
        addressLabel: "Address",
        hoursLabel: "Working hours",
      },
    },
    modal: {
      title: "Get a free quote",
      desc: "Tell us what you need — we'll call you back with a clear, written quote.",
      submit: "Send enquiry",
      sending: "Sending...",
      success: "Enquiry sent!",
      successDesc: "We'll call you back shortly.",
      error: "Could not send. Please try again.",
    },
    footer: {
      about: "Certified electrical installation, industrial automation, custom panel building and energy solutions — with written quotes, on-time delivery and a workmanship warranty on every job.",
      quickLinks: "Quick links",
      servicesTitle: "Services",
      contactTitle: "Contact",
      rebrand: "Formerly known as Neutronics",
      sampleNote: "Contact details, stats and project photos shown are sample placeholders until final business details are provided.",
      rights: "All rights reserved.",
    },
    floating: { whatsapp: "Chat on WhatsApp", call: "Call now" },
  },

  hi: {
    nav: {
      home: "होम",
      services: "सेवाएँ",
      projects: "प्रोजेक्ट्स",
      contact: "संपर्क",
      quote: "मुफ़्त कोटेशन पाएँ",
      call: "अभी कॉल करें",
      switchTo: "EN",
    },
    hero: {
      eyebrow: "इलेक्ट्रिकल • ऑटोमेशन • एनर्जी",
      titleA: "बिजली जो चलती रहे।",
      titleB: "ऑटोमेशन जो फ़ायदा दे।",
      promise:
        "पूरे घर की वायरिंग से प्लांट-व्यापी ऑटोमेशन तक — हम ऐसे इलेक्ट्रिकल सिस्टम प्लान, इंस्टॉल और मेंटेन करते हैं जो वर्षों तक सुरक्षित और भरोसेमंद चलें — लिखित कोटेशन, प्रमाणित काम और 24/7 सहायता के साथ।",
      ctaQuote: "मुफ़्त कोटेशन पाएँ",
      ctaWhatsapp: "WhatsApp पर बात करें",
      badges: ["प्रमाणित टीम", "काम पर वारंटी", "24/7 आपातकालीन सहायता"],
      statCard: { value: "24/7", label: "आपातकालीन सहायता, हमेशा उपलब्ध" },
      projectCard: { value: "500+", label: "प्रोजेक्ट पूर्ण" },
    },
    about: {
      eyebrow: "नेक्स्ट्रॉन के बारे में",
      title: "हर कनेक्शन के पीछे भरोसेमंद हाथ",
      body: "नेक्स्ट्रॉन इलेक्ट्रिकल एंड ऑटोमेशन सोल्यूशंस (पूर्व नाम: न्यूट्रॉनिक्स) इलेक्ट्रिकल इंस्टॉलेशन, औद्योगिक ऑटोमेशन, पैनल बिल्डिंग और एनर्जी समाधानों का एक-ही-झोली का ठेकेदार है। पहले सर्वे से आख़िरी हैंडओवर तक एक ही टीम आपका काम संभालती है — कोई काम दरमियाँ में नहीं छूटता।",
      points: [
        "सर्वे से हैंडओवर तक एक ही संपर्क",
        "पारदर्शी, विस्तृत लिखित कोटेशन",
        "असली सामग्री, प्रमाणित कारीगरी",
        "बिक्री-पश्चात सहायता और 12 महीने की वर्कमैनशिप वारंटी",
      ],
      warrantyBadge: "वर्कमैनशिप वारंटी",
    },
    gallery: {
      eyebrow: "हाल का काम",
      title: "हर दिन ज़मीन पर",
      viewAll: "सभी प्रोजेक्ट्स देखें",
      items: [
        { img: "electrician_wiring", caption: "घर की इलेक्ट्रिफ़िकेशन जारी" },
        { img: "factory_equipment", caption: "मैन्युफ़ैक्चरिंग यूनिट में ऑटोमेशन लाइन" },
        { img: "worker_hardhat", caption: "साइट पर पैनल इंस्टॉलेशन" },
        { img: "solar_roof_workers", caption: "रूफ़टॉप सोलर इंस्टॉलेशन" },
      ],
    },
    homeServices: {
      eyebrow: "आपके घर के लिए",
      title: "होम और स्मार्ट सर्विसेज़",
      subtitle: "छोटे-छोटे काम, उसी दिन — कॉल या WhatsApp पर बुक करें।",
      viewAll: "होम सर्विसेज़ देखें",
      bookNow: "बुक करें",
      items: [
        { id: "cctv", img: "cctv", title: "CCTV कैमरा लगाना", desc: "अंदर-बाहर कैमरे, DVR/NVR और मोबाइल पर लाइव देखने की सुविधा।" },
        { id: "tv", img: "tv_wall", title: "TV वॉल-माउंट और सेटअप", desc: "मज़बूत वॉल-माउंट, तार छिपाना, सेट-टॉप बॉक्स और साउंडबार सेटअप।" },
        { id: "geyser", img: "appliance_service", title: "गीज़र और वॉटर हीटर सर्विस", desc: "इंस्टॉलेशन, डीस्केलिंग और सेफ़्टी चेक — सभी ब्रांड के।" },
        { id: "fridge", img: "appliance_repair", title: "फ्रिज और उपकरण सर्विस", desc: "फ्रिज, वॉशिंग मशीन और घरेलू उपकरणों की रिपेयर — घर पर।" },
        { id: "wifi", img: "wifi_router", title: "WiFi और नेटवर्किंग सेटअप", desc: "रूटर सेटअप, रेंज एक्सटेंडर और पूरे घर में WiFi।" },
        { id: "smart", img: "smart_home", title: "स्मार्ट डिवाइस इंस्टॉलेशन", desc: "स्मार्ट स्विच, वीडियो डोरबेल, लॉक और स्पीकर — सेटअप और डेमो के साथ।" },
      ],
    },
    extraServices: {
      eyebrow: "ऑफ़िस और साइट के लिए",
      title: "संचार और पावर — सब व्यवस्था",
      subtitle: "साइट-से-साइट इंटरनेट, इंटरकॉम, रेडियो और स्टैंडबाई पावर — वही टीम, पूरी सहायता।",
      bookNow: "बुक करें",
      items: [
        { id: "bridge", img: "wireless_bridge", title: "वायरलेस ब्रिज और इंटरनेट शेयरिंग", desc: "दो इमारतों, ऑफ़िस या साइट के बीच इंटरनेट पहुँचाने के लिए पॉइंट-टू-पॉइंट वायरलेस ब्रिज।" },
        { id: "intercom", img: "smart_lock", title: "इंटरकॉम और वीडियो डोर फ़ोन", desc: "घर, ऑफ़िस और अपार्टमेंट के लिए ऑडियो-वीडियो इंटरकॉम।" },
        { id: "walkie", img: "walkie_talkie", title: "वॉकी-टॉकी (टू-वे रेडियो)", desc: "साइट, इवेंट और सिक्योरिटी टीमों के लिए रेडियो सेट — सप्लाई और प्रोग्रामिंग।" },
        { id: "dg", img: "dg_rent", title: "डीज़ल जनरेटर (DG) किराए पर", desc: "फ़ंक्शन, साइट और बैकअप पावर के लिए साइलेंट DG सेट — डिलीवरी और इंस्टॉलेशन के साथ।" },
      ],
    },
    smallJobs: {
      eyebrow: "रोज़मर्रा के काम",
      title: "घर के छोटे इलेक्ट्रिकल काम",
      subtitle: "एक कॉल और नेक्स्ट्रॉन का इलेक्ट्रिशियन आपके दरवाज़े पर — छोटे काम उसी दिन।",
      items: [
        { id: "fan", img: "ceiling_fan", title: "सीलिंग फ़ैन लगाना" },
        { id: "light", img: "lights", title: "लाइट और झूमर लगाना" },
        { id: "switchboard", img: "electrician_wiring", title: "स्विचबोर्ड और सॉकेट रिपेयर" },
        { id: "inverter", img: "appliance_repair", title: "इनवर्टर और बैटरी सेटअप" },
        { id: "doorbell", img: "cctv", title: "डोरबेल और वायरिंग सुधार" },
        { id: "mcb", img: "breakers", title: "MCB और फ़्यूज़ रिपेयर" },
      ],
    },
    stats: [
      { value: 500, suffix: "+", label: "प्रोजेक्ट पूर्ण" },
      { value: 15, suffix: "+", label: "वर्षों का अनुभव" },
      { value: 250, suffix: "+", label: "संतुष्ट ग्राहक" },
      { value: 24, suffix: "/7", label: "आपातकालीन सहायता" },
    ],
    steps: {
      eyebrow: "यह कैसे काम करता है",
      title: "पहली कॉल से काम के सौंपने तक — 3 आसान चरण",
      subtitle: "कोई छिपा शुल्क नहीं, कोई उलझन नहीं — शुरू से अंत तक साफ़ प्रक्रिया।",
      items: [
        {
          title: "अपनी आवश्यकता बताएँ",
          desc: "कॉल, WhatsApp या फ़ॉर्म से बताएं — एक छोटी खराबी हो या पूरे प्लांट का ऑटोमेशन, दोनों लेते हैं।",
        },
        {
          title: "मुफ़्त सर्वे और लिखित कोटेशन",
          desc: "हमारे इंजीनियर साइट देखकर साफ़, विस्तृत लिखित कोटेशन देते हैं। बिल्कुल मुफ़्त।",
        },
        {
          title: "इंस्टॉलेशन, टेस्टिंग और सहायता",
          desc: "प्रमाणित इंस्टॉलेशन, पूरी टेस्टिंग और हैंडओवर — साथ में बिक्री-पश्चात सहायता और वारंटी।",
        },
      ],
    },
    servicesTeaser: {
      eyebrow: "हम क्या करते हैं",
      title: "इलेक्ट्रिकल और ऑटोमेशन — शुरू से अंत तक",
      subtitle: "वायरिंग, पैनल, ऑटोमेशन, मेंटेनेंस और पावर समाधान — सब एक टीम से।",
      customTitle: "कुछ अलग चाहिए?",
      customDesc: "अपनी समस्या बताएं — हम सही इलेक्ट्रिकल या ऑटोमेशन समाधान सुझाएंगे।",
      customCta: "हमसे बात करें",
      viewAll: "सभी सेवाएँ देखें",
    },
    why: {
      eyebrow: "हमें क्यों चुनें",
      title: "भरोसेमंद काम, आसानी से उपलब्ध लोग",
      items: [
        { title: "प्रमाणित और सुरक्षित काम", desc: "प्रशिक्षित इलेक्ट्रिशियन, असली सामग्री और हर काम में पूरे सुरक्षा मानक।" },
        { title: "समय पर डिलीवरी", desc: "हम समय-सीमा तय करके निभाते हैं — न अंतहीन देरी, न बहाने।" },
        { title: "काम पर वारंटी", desc: "हमारे इंस्टॉलेशन और पैनल पर 12 महीने की वर्कमैनशिप वारंटी।" },
        { title: "अनुभवी टीम", desc: "वर्षों के इंडस्ट्रियल और कमर्शियल अनुभव वाली टीम हर प्रोजेक्ट संभालती है।" },
      ],
    },
    faq: {
      eyebrow: "सामान्य प्रश्न",
      title: "कॉल करने से पहले लोग जो पूछते हैं",
      items: [
        { q: "सर्वे या कोटेशन के लिए शुल्क है?", a: "नहीं। साइट सर्वे और लिखित कोटेशन पूरी तरह मुफ़्त हैं — कोई बाध्यता नहीं।" },
        { q: "काम कितने दिन में शुरू होता है?", a: "कोटेशन स्वीकृति के बाद ज़्यादातर काम 2–5 कार्यदिवस में शुरू होते हैं। आपातकालीन सहायता उसी दिन।" },
        { q: "आप किन क्षेत्रों में काम करते हैं?", a: "हम शहर और आसपास के औद्योगिक क्षेत्रों में काम करते हैं; बड़े प्रोजेक्ट पूरे राज्य में लेते हैं।" },
        { q: "क्या काम पर वारंटी मिलती है?", a: "हाँ — हमारे इंस्टॉलेशन और बनाए पैनल पर 12 महीने की वर्कमैनशिप वारंटी, और उपकरण पर कंपनी वारंटी।" },
        { q: "क्या छोटे घरेलू काम करते हैं?", a: "हाँ। एक वायरिंग खराबी से लेकर पूरे घर की इलेक्ट्रिफ़िकेशन तक — कोई काम छोटा नहीं।" },
        { q: "पुरानी मशीन या पैनल ऑटोमेट कर सकते हैं?", a: "हाँ — मौजूदा मशीनों, लाइनों और पैनल में PLC/VFD ऑटोमेशन रेट्रोफ़िट करते हैं, बिना लंबा प्रोडक्शन रोके।" },
      ],
    },
    finalCta: {
      title: "चाहते हैं बिजली जो बिना रुकावट चले?",
      subtitle: "एक संदेश भेजें। 24 घंटे में मुफ़्त कोटेशन पाएँ — या आपातकाल में सीधे कॉल करें।",
      call: "अभी कॉल करें",
      whatsapp: "WhatsApp करें",
      quote: "मुफ़्त कोटेशन पाएँ",
    },
    servicesPage: {
      eyebrow: "सेवाएँ",
      title: "आपको परिचालित रखने के 5 तरीके",
      subtitle: "घर, दुकान, फ़ैक्टरी और इंफ़्रास्ट्रक्चर के लिए इलेक्ट्रिकल, ऑटोमेशन और एनर्जी काम — लिखित कोटेशन और वारंटी के साथ।",
      enquire: "पूछताछ करें",
      standardsTitle: "हमारे मानक और प्रथाएँ",
      standards: ["IS / IEC वायरिंग मानक", "IP-रेटेड पैनल एनक्लोज़र", "हर काम से पहले लोड स्टडी", "हैंडओवर पर टेस्ट रिपोर्ट", "अर्थिंग व सेफ़्टी ऑडिट रिपोर्ट"],
      items: [
        {
          id: "electrical",
          title: "इलेक्ट्रिकल इंस्टॉलेशन और वायरिंग",
          desc: "घर, दुकान और फ़ैक्टरी की पूरी इलेक्ट्रिफ़िकेशन — सुरक्षित वायरिंग जो पहली बार में ही जाँच पास करे।",
          features: ["घर और दुकान की पूरी इलेक्ट्रिफ़िकेशन", "इंडस्ट्रियल हैवी वायरिंग और केबलिंग", "कंड्यूट, अर्थिंग और सुरक्षा मानक"],
        },
        {
          id: "automation",
          title: "औद्योगिक ऑटोमेशन और कंट्रोल पैनल",
          desc: "PLC, VFD और SCADA आधारित ऑटोमेशन — मैनुअल ग़लतियाँ कम, उत्पादन ज़्यादा।",
          features: ["PLC / SCADA और HMI प्रोग्रामिंग", "VFD और मोटर कंट्रोल ऑटोमेशन", "पुरानी मशीनों व लाइनों में रेट्रोफ़िट"],
        },
        {
          id: "panels",
          title: "कस्टम पैनल बिल्डिंग",
          desc: "आपके लोड के हिसाब से बने पैनल — वायर्ड, लेबल्ड और डिस्पैच से पहले टेस्टेड।",
          features: ["LT/HT पैनल, APFC और MCC", "डिस्ट्रिब्यूशन बोर्ड (DB) और स्विचगियर", "लोड कैलकुलेशन और टेस्टिंग"],
        },
        {
          id: "maintenance",
          title: "मेंटेनेंस और ब्रेकडाउन सहायता",
          desc: "नियमित देखभाल और तेज़ ब्रेकडाउन रिस्पॉन्स — आपका उत्पादन ज़्यादा देर न रुके।",
          features: ["प्रिवेंटिव मेंटेनेंस कॉन्ट्रैक्ट", "24/7 ब्रेकडाउन सहायता", "थर्मल स्कैनिंग और सेफ़्टी ऑडिट"],
        },
        {
          id: "power",
          title: "पावर और एनर्जी समाधान",
          desc: "सोलर, सर्ज प्रोटेक्शन और एनर्जी-सेविंग अपग्रेड — बिजली का बिल कम।",
          features: ["रूफ़टॉप सोलर और नेट-मीटरिंग", "सर्ज प्रोटेक्शन और पावर कंडीशनिंग", "एनर्जी-सेविंग अपग्रेड"],
        },
      ],
    },
    projectsPage: {
      eyebrow: "प्रोजेक्ट्स",
      title: "हमने जो काम किए",
      subtitle: "हर दिन हम जिस तरह के इंस्टॉलेशन और ऑटोमेशन संभालते हैं — एक झलक।",
      filters: { all: "सभी", industrial: "औद्योगिक ऑटोमेशन", panels: "पैनल व स्विचगियर", wiring: "कमर्शियल वायरिंग", energy: "स्मार्ट एनर्जी" },
      items: [
        { img: "panel_testing", cat: "industrial", title: "टेक्सटाइल प्लांट में PLC कंट्रोल पैनल कमीशनिंग", meta: "औद्योगिक · 2024" },
        { img: "panel_wiring", cat: "panels", title: "प्रोसेस ऑटोमेशन के लिए 480-पॉइंट कंट्रोल पैनल वायरिंग", meta: "पैनल व स्विचगियर · 2024" },
        { img: "breakers", cat: "panels", title: "कमर्शियल कॉम्प्लेक्स के लिए LT डिस्ट्रिब्यूशन पैनल अपग्रेड", meta: "पैनल व स्विचगियर · 2023" },
        { img: "switchbox", cat: "wiring", title: "शो-फ़्लोर की पूरी वायरिंग और DB इंस्टॉलेशन", meta: "कमर्शियल वायरिंग · 2024" },
        { img: "solar_farm", cat: "energy", title: "रूफ़टॉप सोलर और नेट-मीटरिंग इंटीग्रेशन", meta: "स्मार्ट एनर्जी · 2023" },
        { img: "solar_tech", cat: "energy", title: "वेयरहाउस के लिए सर्ज प्रोटेक्शन और अर्थिंग ऑडिट", meta: "स्मार्ट एनर्जी · 2024" },
        { img: "solar_panels", cat: "energy", title: "ऑफ़िस पार्क के लिए स्मार्ट एनर्जी मॉनिटरिंग", meta: "स्मार्ट एनर्जी · 2025" },
        { img: "factory_machine", cat: "industrial", title: "मैन्युफ़ैक्चरिंग यूनिट की प्रोडक्शन लाइन में ऑटोमेशन रेट्रोफ़िट", meta: "औद्योगिक · 2025" },
        { img: "solar_roof_workers", cat: "energy", title: "रूफ़टॉप सोलर ऐरे पूरा करती इंस्टॉलेशन टीम", meta: "स्मार्ट एनर्जी · 2025" },
        { img: "breakers_white", cat: "panels", title: "कोल्ड-स्टोरेज यूनिट के लिए ब्रेकर इंटरलॉक वाला फ़ीडर पैनल", meta: "पैनल व स्विचगियर · 2024" },
      ],
      note: "नमूना गैलरी — कंपनी के वास्तविक काम की फ़ोटो और कैप्शन से बदले जाएँगे।",
    },
    contactPage: {
      eyebrow: "संपर्क",
      title: "बताएं आपको क्या चाहिए",
      subtitle: "फ़ॉर्म भरें — हम आमतौर पर उसी कार्य दिवस में वापस कॉल करते हैं। या सीधे नीचे संपर्क करें।",
      form: {
        name: "आपका नाम",
        namePh: "जैसे: राहुल शर्मा",
        phone: "फ़ोन नंबर",
        phonePh: "+91 ...",
        email: "ईमेल (वैकल्पिक)",
        emailPh: "you@example.com",
        service: "आवश्यक सेवा",
        servicePh: "आपको क्या चाहिए?",
        other: "अन्य / पक्का नहीं",
        message: "आपका संदेश",
        messagePh: "काम के बारे में बताएं — जगह, आकार, समय-सीमा...",
        submit: "पूछताछ भेजें",
        sending: "भेज रहे हैं...",
        success: "पूछताछ भेज दी गई!",
        successDesc: "हम जल्द ही कॉल या WhatsApp करेंगे। कुछ ज़रूरी हो तो WhatsApp पर संदेश करें।",
        error: "भेजा नहीं जा सका। फिर कोशिश करें या WhatsApp करें।",
      },
      info: {
        title: "सीधा संपर्क",
        phoneLabel: "कॉल करें",
        whatsappLabel: "WhatsApp",
        emailLabel: "ईमेल",
        addressLabel: "पता",
        hoursLabel: "कार्य समय",
      },
    },
    modal: {
      title: "मुफ़्त कोटेशन पाएँ",
      desc: "बताएं आपको क्या चाहिए — हम साफ़, लिखित कोटेशन के साथ वापस कॉल करेंगे।",
      submit: "पूछताछ भेजें",
      sending: "भेज रहे हैं...",
      success: "पूछताछ भेज दी गई!",
      successDesc: "हम जल्द ही वापस कॉल करेंगे।",
      error: "भेजा नहीं जा सका। फिर कोशिश करें।",
    },
    footer: {
      about: "प्रमाणित इलेक्ट्रिकल इंस्टॉलेशन, औद्योगिक ऑटोमेशन, कस्टम पैनल बिल्डिंग और एनर्जी समाधान — लिखित कोटेशन, समय पर डिलीवरी और हर काम पर वर्कमैनशिप वारंटी के साथ।",
      quickLinks: "त्वरित लिंक",
      servicesTitle: "सेवाएँ",
      contactTitle: "संपर्क",
      rebrand: "पूर्व नाम: न्यूट्रॉनिक्स",
      sampleNote: "दिखाए गए संपर्क विवरण, आँकड़े और प्रोजेक्ट फ़ोटो नमूना हैं — अंतिम व्यावसायिक जानकारी मिलने पर बदले जाएँगे।",
      rights: "सर्वाधिकार सुरक्षित।",
    },
    floating: { whatsapp: "WhatsApp पर बात करें", call: "अभी कॉल करें" },
  },
};
